<template>
    <div class="page-wrapper">
        <v-snackbar
                v-model="notification"
                :color="notification_type"
                :timeout="5000"
                :top="true"
        >
            {{ notification_message }}
            <v-btn

                    text
                    @click="notification = false"
            >
                Close
            </v-btn>
        </v-snackbar>

        <v-container
                fill-height
                fluid
                grid-list-xl>
            <v-layout
                    justify-center
                    wrap>
                <v-flex
                        xs12
                        md12
                >
                    <v-flex xs12>
                        <v-card
                                class="pa-4"
                                flat
                        >
                            <v-toolbar
                                    dense
                            >
                                <v-text-field
                                        hide-details
                                        single-line
                                        label="Name"
                                        v-model="search.customer"
                                ></v-text-field>

                                <v-btn
                                        @click="filter_results(search)"
                                        icon
                                        color="blue-grey darken-4">
                                    <v-icon>
                                        mdi-magnify
                                    </v-icon>
                                </v-btn>
                            </v-toolbar>
                        </v-card>
                    </v-flex>

                    <v-toolbar flat color="white">
                        <v-toolbar-title>Live Orders</v-toolbar-title>
                        <v-divider
                                class="mx-4"
                                inset
                                vertical
                        ></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-simple-table>
                        <thead>
                        <tr>
                            <th>#</th>
                            <th class="text-left">Customer</th>
                            <th class="text-center">Price</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in orders" :key="index">
                            <td>
                                {{ index }}
                            </td>
                            <td>{{ item.customer }}</td>
                            <td class="text-center">¥{{ item.total.price__sum }}</td>
                        </tr>
                        <tr>
                            <td>Totals</td>
                            <td>{{ totals.customers }}</td>
                            <td class="text-center">
                                ¥{{ totals.amount }}
                            </td>
                        </tr>
                        </tbody>
                    </v-simple-table>
                </v-flex>
            </v-layout>
        </v-container>

    </div>
</template>


<script>
    export default {
        components: {},
        data() {
            return {
                orders: [],
                notification_type: 'success',
                notification_message: '',
                notification: false,
                search: {},
                search_url: '',
                totals: {
                    amount:0,
                    customers: 0
                },
                interval: null
            }
        },
        computed: {},
        created() {
            // this.id = parseInt(this.$route.params.id);
            this.load_orders();
            this.interval = setInterval(() => this.load_orders(), 20000);

        },
        beforeDestroy () {
            clearInterval(this.interval)
        },
        methods: {
            load_orders() {
                this.$http.get(
                    this.$http.defaults.baseURL + '/admin/live-orders/').then((response) => {

                    this.notification = false;
                    this.notification_message = '';
                    this.total_amount = 0;
                    let self = this;
                    this.totals = {
                        amount:0,
                        customers: 0
                    };
                    response.data.forEach(function(order){
                        self.totals.amount += order.total.price__sum;
                        self.totals.customers ++;
                    });
                    this.orders = response.data;
                })
                    .catch((error) => {
                        this.notification = true;
                        this.notification_message = 'Error: Please contact administrator';
                        console.log("Error");
                        console.log(error);
                    });
            },
            mark_as_free(item) {
                if (confirm('Are you sure you want to mark this item as free ?')) {
                    let send_data = {
                        id: item.id,
                        price: 0
                    };

                    this.$http.patch(
                        this.$http.defaults.baseURL + '/admin/order-lines/' + item.id + '/', send_data).then((response) => {
                        this.notification = true;
                        this.notification_message = 'Successfully updated';
                        this.notification_type = 'success';
                        item.price = 0;
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }
            },
            mark_as_default_price(item) {
                if (confirm('Are you sure you want to mark this item as free ?')) {
                    let send_data = {
                        id: item.id,
                        price: item.product.price
                    };

                    this.$http.patch(
                        this.$http.defaults.baseURL + '/admin/order-lines/' + item.id + '/', send_data).then((response) => {
                        this.notification = true;
                        this.notification_message = 'Successfully updated';
                        this.notification_type = 'success';
                        item.price = item.product.price;
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }
            },
            filter_results(search) {
                let search_url = '';
                for (let prop in search) {
                    // skip loop if the property is from prototype
                    if (!search.hasOwnProperty(prop)) continue;

                    // your code
                    search_url += '&' + prop + '=' + search[prop];
                }
                this.search_url = search_url;
                this.load_orders();
            },
            delete_order(item) {
                if (confirm('Are you sure you wish to delete this item from the order? ')) {
                    this.$http.delete(
                        this.$http.defaults.baseURL + '/admin/order-lines/' + item.id + '/').then((response) => {
                        console.log(response);
                        this.notification = true;
                        this.notification_type = 'success';
                        this.notification_message = 'Successfully Deleted';
                        this.load_orders()
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }
            }
        },
    }
</script>
